export interface Location {
  primaryContact: PrimaryContact;
  address: string;
  city: string;
  id: string;
  name: string;
  state: string;
  zip?: string;
}

export interface PrimaryContact {
  email: string;
  name: string;
  phone: string;
}

export interface Appointment {
  caseCategory: string;
  caseType: string;
  details: string;
  dob: string;
  duration: number;
  email: string;
  facility: string;
  gender: string;
  id: string;
  location: Location;
  primaryContact: PrimaryContact;
  name: string;
  notes: string;
  orgCode: string;
  orgName: string;
  patientKey: string;
  scheduledBy: string;
  start: Date | null;
  end: Date | null;
  statusId: AppointmentStatus;
  type: string;
  updateTime: Date | null;
  with: string;
  googleCalendarEventId?: string | null;
  facilityPhone?: string;
  link?: string | null;
}

export enum AppointmentStatus {
  SCHEDULED = 0,
  CHECKED_IN = 1,
  COMPLETED = 2,
  NO_SHOW = 3,
  CANCELLED = 4,
  RESCHEDULED = 5,
  LATE_CANCELLED = 6,
  LATE_RESCHEDULED = 7,
}

export interface UpdateAppointmentStatusRequest {
  providerOrgCode: string;
  patientKey: string;
  appointmentId: string;
  action?: 'COMPLETE' | 'UNDO';
  targetStatusId?: AppointmentStatus;
}

export interface UpdateAppointmentStatusResponse {
  success: boolean;
  appointmentId: string;
  patientKey: string;
  previousStatusId: AppointmentStatus;
  statusId: AppointmentStatus;
  updateTime: string;
}
